import React from "react";
import OverlayContainer from "../OverlayContainer";
import { withRouter, useParams, useNavigate } from "react-router";
import axiosInstance from "../../../axios";
import { CourseBuilderStaticData } from "../../../_constants/staticData";
const SaveDraft = ({ history, handleClose, formValues, Submit, current }) => {
  const navigate = useNavigate();
  let { id } = useParams();

  const handleSaveCourse = async (courseId) => {
    const payload = {
      courseType: formValues.courseType,
      liveWebinarCourse: formValues.liveWebinarCourse,
      courseName: formValues.courseName,
      category: formValues.category,
      subCategory: formValues.subCategory,
      IsAdult: formValues.IsAdult,
      goals: formValues.goals?.length > 1 ? formValues?.goals : [],
      courseOneLiner: formValues.courseOneLiner,
      courseOutDescription: formValues.courseOutDescription,
      preRequisites:
        formValues.preRequisites?.length > 1 ? formValues?.preRequisites : [],
      description:
        formValues.description !== null ? formValues.description : "",
      faqs: formValues.faqs?.length > 1 ? formValues.faqs : [],
      syllabus: formValues.syllabus?.length > 1 ? formValues?.syllabus : [],
      level: formValues.level,
      language: formValues.language,
      duration: formValues.duration,
      imageFiles: formValues.imageFiles,
      videoFiles: formValues.videoFiles,
      scheduleEvent: formValues.scheduleEvent,
      courseSections:
        formValues.courseSections?.length > 1 ? formValues?.courseSections : [],
      isFree: formValues.isFree,
      currency: "INR",
      enrollmentFee: formValues.enrollmentFee,
      promotionalOffer: formValues.promotionalOffer,
      promotionalCode: formValues.promotionalCode,
      discountPercent: formValues.discountPercent,
      status: formValues.status,
    };
    try {
      await axiosInstance.put(`/course/${courseId}`, payload);
      navigate("/dashboard/courses");
    } catch (error) {
      console.error("Error saving course draft:", error);
    }
  };

  const handleCancel = async (courseId) => {
  try {
    await axiosInstance.post("course/delete", { courseId: courseId });
    navigate("/dashboard");
  } catch (error) {
    console.error("Error cancelling course draft:", error);
  }
};

  return (
    <OverlayContainer>
      <div className="alert-dialog-inner">
        <div className="alert-dialog-close" onClick={handleClose}>
          <div>
            <i className="icon check"></i>
          </div>
        </div>
        <div className="alert-title">Warning!</div>
        <div className="alert-message">
          {CourseBuilderStaticData.saveDraftOverlay.header}
        </div>

        <div className="alert-close-btn">
          <a
            className={current < 8 ? "course-disable" : ""}
            onClick={() => handleSaveCourse(id)}
          >
            SAVE
          </a>

          <a className="btn-cancel" onClick={() => handleCancel(id)}>
            CANCEL
          </a>
        </div>
      </div>
    </OverlayContainer>
  );
};

export default SaveDraft;
